export default __webpack_public_path__ + "static/media/course_detail_youtube.257ba551.png";